import { EnvironmentParameter } from './basic';

export const environment: EnvironmentParameter = new EnvironmentParameter();

environment.production = true;

/**==IFrame变量==**/
environment.IFrameHost = '../old/2022CFA.html?t=' + new Date().valueOf() + '#!/';
